import { X, Loader2 } from 'lucide-react'
import type { HistoryRecord } from '../../types/promptcraft'

interface PromptCraftHistoryModalProps {
  historyRecords: HistoryRecord[]
  historyLoading: boolean
  onClose: () => void
  onRestore: (record: HistoryRecord) => void
  onRefresh: () => void
}

export function PromptCraftHistoryModal({
  historyRecords, historyLoading, onClose, onRestore, onRefresh,
}: PromptCraftHistoryModalProps) {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-[#161b22] rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden border border-cyan-900/30" onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-cyan-900/30 flex items-center justify-between">
          <h2 className="text-lg font-medium text-white">历史记录</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto max-h-[60vh]">
          {historyLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="w-6 h-6 animate-spin text-cyan-400" />
            </div>
          ) : historyRecords.length === 0 ? (
            <div className="text-center py-8 text-gray-500">暂无历史记录</div>
          ) : (
            <div className="space-y-3">
              {historyRecords.map((record) => (
                <button
                  key={record.id}
                  onClick={() => onRestore(record)}
                  className="w-full text-left bg-[#0d1117] hover:bg-cyan-900/20 rounded-lg p-3 transition-colors border border-cyan-900/20"
                >
                  <p className="text-white font-medium truncate">{record.seed_prompt}</p>
                  <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
                    {record.style_preference && <span className="bg-cyan-900/30 text-cyan-400 px-2 py-0.5 rounded">{record.style_preference}</span>}
                    <span>{record.aspect_ratio}</span>
                    <span>{new Date(record.created_at).toLocaleString()}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="px-6 py-3 border-t border-cyan-900/30">
          <button onClick={onRefresh} disabled={historyLoading} className="text-sm text-cyan-400 hover:text-cyan-300">
            刷新
          </button>
        </div>
      </div>
    </div>
  )
}
